import Logo from "../../assets/img/Logo.jpeg";

export { Logo };

export const HttpCodes = {
     Unauthorized: 401,
     Forbidden: 403,
     NotFound: 404,
     InternalServerError: 500,
     BadRequest: 400,
     UnprocessableEntity: 422,
     Success: 200,
     Created: 201,
};

export const AppName = "Premium Lending Limited";
export const AppShortName = "Premium Lending";
